import { gql } from '@apollo/client';

export const TerminateCallAction = gql`
    mutation terminateCallAction($active: Boolean!, $agentId: ID!) {
        terminateCallAction(active: $active, agentId: $agentId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
